import { Directive, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

@Directive()
export abstract class SubscriptionTracker implements OnDestroy {
    private readonly subscriptions: Subscription[] = [];

    protected _track(...subscriptions: Subscription[]): void {
        this.subscriptions.push(...subscriptions);
    }

    ngOnDestroy(): void {
        while (this.subscriptions.length > 0) {
            this.subscriptions.pop()?.unsubscribe();
        }
    }
}
